var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"title"},[_c('div',{staticClass:"left_hr"}),_c('div',{staticClass:"text"},[_vm._v(_vm._s(_vm.Msg))]),_c('div',{staticClass:"right_hr"})])}
var staticRenderFns = []

export { render, staticRenderFns }